import { create } from 'zustand';

export type UserInitializationState = 'idle' | 'loading' | 'done';

interface UserInitializationStore {
  state: UserInitializationState;
  setState: (newState: UserInitializationState) => void;
  reset: () => void;
}

export const useUserInitialization = create<UserInitializationStore>(set => ({
  state: 'idle',
  setState: newState => set({ state: newState }),
  reset: () => set({ state: 'idle' }),
}));
